import { INBOX_TYPES } from 'dashboard/helper/inbox';

// DV: getInboxSource was removed from dashboard/helper/inbox in Chatwoot 4.18;
// our message channel label and channel picker still need it.
export const getInboxSource = (type, phoneNumber, inbox = {}) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return inbox.website_url || '';

    case INBOX_TYPES.TWILIO:
    case INBOX_TYPES.WHATSAPP:
      return phoneNumber || '';

    case INBOX_TYPES.EMAIL:
      return inbox.email || '';

    default:
      return '';
  }
};
